import { render } from "./SlideTransition.vue?vue&type=template&id=062208ae&ts=true"
import script from "./SlideTransition.vue?vue&type=script&lang=ts"
export * from "./SlideTransition.vue?vue&type=script&lang=ts"

import "./SlideTransition.vue?vue&type=style&index=0&id=062208ae&lang=stylus"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__